import React, { useState } from "react";
import { Button, Modal } from "antd";

const WorkerAttendance = () => {
  const workers = [
    { id: 1, name: "John Doe" },
    { id: 2, name: "Aisha Khan" },
    { id: 3, name: "Ravi Patel" },
    { id: 4, name: "Maria Garcia" },
  ];

  const daysInMonth = new Date().getMonth() === 1 ? 28 : 30;

  const mockMonthlyAttendance = workers.reduce((acc, worker) => {
    const monthData = {};
    for (let day = 1; day <= daysInMonth; day++) {
      const statuses = ["present", "absent", "half-day"];
      const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
      monthData[day] = randomStatus;
    }
    acc[worker.id] = monthData;
    return acc;
  }, {});

  const [attendance, setAttendance] = useState(() =>
    workers.reduce((acc, worker) => {
      acc[worker.id] = "present";
      return acc;
    }, {})
  );

  const [selectedWorkerId, setSelectedWorkerId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleChange = (workerId, status) => {
    setAttendance((prev) => ({
      ...prev,
      [workerId]: status,
    }));
  };

  const handleSubmit = () => {
    console.log("Submitted Attendance:", attendance);
    alert("✅ Attendance marked successfully!");
  };

  const showWorkerAttendance = (workerId) => {
    setSelectedWorkerId(workerId);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedWorkerId(null);
  };

  const styles = {
    container: {
      padding: "30px",
      maxWidth: "700px",
      margin: "40px auto",
      borderRadius: "12px",
      boxShadow: "0 0 15px rgba(0,0,0,0.1)",
      background: "#fff",
      fontFamily: "Arial, sans-serif",
    },
    header: {
      textAlign: "center",
      marginBottom: "25px",
      color: "#333",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 16px",
      borderBottom: "1px solid #eee",
      borderRadius: "6px",
      background: "#f9f9f9",
      marginBottom: "10px",
      cursor: "pointer",
    },
    name: {
      fontSize: "16px",
      fontWeight: "500",
    },
    select: {
      padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "14px",
    },
    button: {
      display: "block",
      width: "100%",
      padding: "12px",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#fff",
      backgroundColor: "#007bff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      marginTop: "20px",
    },
    calendarContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      maxHeight: "60vh",
      overflowY: "auto",
    },
    calendarDay: {
      width: "70px",
      margin: "5px",
      padding: "10px",
      textAlign: "center",
      borderRadius: "8px",
      backgroundColor: "#f0f0f0",
      fontSize: "14px",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>📝 Worker Attendance</h2>
      <Button style={{ marginBottom: "20px" }}>+ Add Worker</Button>

      {workers.map((worker) => (
        <div key={worker.id} style={styles.row} onClick={() => showWorkerAttendance(worker.id)}>
          <span style={styles.name}>{worker.name}</span>
          <select
            style={styles.select}
            value={attendance[worker.id]}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => handleChange(worker.id, e.target.value)}
          >
            <option value="present">✅ Present</option>
            <option value="half-day">🕒 Half Day</option>
            <option value="absent">❌ Absent</option>
          </select>
        </div>
      ))}

      <button style={styles.button} onClick={handleSubmit}>
        Submit Attendance
      </button>

      <Modal
        title={`📅 Monthly Attendance: ${
          selectedWorkerId ? workers.find((w) => w.id === selectedWorkerId).name : ""
        }`}
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={[
          <Button key="close" type="primary" onClick={handleCloseModal}>
            Close
          </Button>,
        ]}
        width={window.innerWidth < 500 ? "95%" : 600}
        bodyStyle={{ padding: "10px 20px" }}
      >
        <div style={styles.calendarContainer}>
          {selectedWorkerId &&
            Object.entries(mockMonthlyAttendance[selectedWorkerId]).map(([day, status]) => (
              <div key={day} style={styles.calendarDay}>
                <strong>Day {day}</strong>
                <br />
                {status === "present" && "✅"}
                {status === "absent" && "❌"}
                {status === "half-day" && "🕒"}
              </div>
            ))}
        </div>
      </Modal>
    </div>
  );
};

export default WorkerAttendance;
